import styled from "styled-components";
const Wrapper = styled.div`
  position: relative;
  width: auto;
`;
export default Wrapper;
